document.querySelectorAll('[data-target]').forEach(button => {

    button.addEventListener('click', function(e) {

        e.preventDefault();

        const target = document.querySelector(this.dataset.target);

        if (!target) return;

        const offset = 80;

        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top,
            behavior: 'smooth'
        });

    });

});




const diagnosticoTrigger = document.querySelector(
    '.btnDiagnostico a'
);

/* const diagnosticoFloat = document.querySelector(
    '[data-diagnostico-float].diagnostico-float'
); */
const diagnosticoMobile = document.querySelector(
    '[data-diagnostico-float].diagnostico-mobile'
);

const diagnosticoArea = document.querySelector(
    '.diagnostico-area'
);

const toggleDiagnosticoFloat = (show) => {

    //diagnosticoFloat?.classList.toggle('is-visible', show);
    diagnosticoMobile?.classList.toggle('is-visible', show);

};


if (diagnosticoTrigger && diagnosticoMobile) {  
    // CTA aparece depois da Hero
    ScrollTrigger.create({

        trigger: diagnosticoTrigger,

        start: 'bottom top-=20',

        onEnter: () => {
            toggleDiagnosticoFloat(true);
        },

        onLeaveBack: () => {
            toggleDiagnosticoFloat(false);
        }

    });

}

// CTA desaparece durante TODO o diagnóstico
if (diagnosticoArea) {

    ScrollTrigger.create({

        trigger: diagnosticoArea,

        start: 'top bottom',
        end: 'bottom top',

        onEnter: () => {
            toggleDiagnosticoFloat(false);
        },

        onEnterBack: () => {
            toggleDiagnosticoFloat(false);
        },

        onLeave: () => {
            toggleDiagnosticoFloat(true);
        },

        onLeaveBack: () => {
            toggleDiagnosticoFloat(true);
        }

    });

}











document.addEventListener('DOMContentLoaded', function () {

    const sliderMonitoramento = document.querySelector('.monitoramento__slider');

    if (!sliderMonitoramento) return;

    new Splide('.monitoramento__slider', {

        perPage: 4,
        perMove: 1,

        gap: '30px',

        padding: {
            right: '40px'
        },

        rewind: true,

        autoplay: true,
        interval: 3500,

        speed: 600,

        drag: true,
        snap: true,

        arrows: false,
        pagination: false,

        dragMinThreshold: {
            mouse: 0,
            touch: 10
        },

        breakpoints: {
            1536: {
                perPage: 3,
                padding: { right: '6rem' }
            },
            1280: {
                perPage: 3,
                padding: { right: '5rem' }
            },
            1200: {
                perPage: 2,
                padding: { right: '5rem' }
            },
            768: {
                perPage: 1,
                padding: { right: '4rem' }
            }
        }

    }).mount();

});


async function loadResult() {

    const error = document.querySelector('.error');
    //const btn = document.querySelector('.diagnostico__cta a');
    //btn.style.display = 'none';

    // Validação das perguntas
    for (let i = 1; i <= 18; i++) {
        if (!document.querySelector(`input[name="q${i}"]:checked`)) {
            error.textContent = `Responda a pergunta ${i} para continuar.`;
            // Opcional: faz scroll até a pergunta não respondida
            const pergunta = document.querySelector(`input[name="q${i}"]`)
                .closest('.diagnostico__pergunta');
            
                setTimeout(() => {
                    //btn.style.display = '';
                    error.textContent = '';
                },1000);
                setTimeout(() => {
                    window.scrollTo({
                        top: pergunta.getBoundingClientRect().top + window.pageYOffset - 100,
                        behavior: 'smooth'
                    });
                },1200);
               

            return;
        }
    }

    // Estado carregando
    const btnLoader = document.querySelector('.diagnostico__cta .loaderContent');
    //btnLoader.style.display = '';

    const wrapper = document.querySelector('.lp-metodo-sieg');
    const loader = document.querySelector('.diagnostico-loader');

    loader.classList.add('active');

    const grupos = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
    };

    document.querySelectorAll('.section-diagnostico input[type="radio"]:checked')
        .forEach(input => {
            grupos[input.dataset.group] += Number(input.value);
        });


    try {

        const ajaxurl = document.querySelector('.diagnostico__form').dataset.ajaxurl;

        const response = await fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                action: 'diagnostico_resultado',
                grupos: JSON.stringify(grupos)
            })
        });

        const data = await response.json();

        if (!data.success) {
            throw new Error(data.data);
        }

        renderHeader(data.data);
        renderDimensions(data.data.dimensoes);
        renderTimeline(data.data.evolucao);        

        const diagnostico = document.querySelector('.section-diagnostico');
        const result = document.querySelector('.diagnostico-result');

        diagnostico.style.display = 'none';
        result.style.display = '';       

        setTimeout(() => {   
            const posicao = result.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo(0, posicao);
        }, 1000);

        setTimeout(() => {
            loader.classList.remove('active');
        }, 2000);


    } catch(error) {

        console.error(error);

        alert('Não foi possível calcular o resultado. Tente novamente.');

        //btn.style.display = '';
        btnLoader.style.display = 'none';
        loader.classList.remove('active');
    }

}

/* document.querySelector('.diagnostico__cta a').addEventListener('click', function(e){

    e.preventDefault();

    loadResult();

}); */


function renderHeader(data) {

    document.querySelector("#score-number").textContent = data.score;

    document.querySelector("#score-total").textContent =
        `de ${data.maxScore} pontos`;

    document.querySelector("#level-name").innerHTML =
        data.nivelTitle;

    document.querySelector("#level-description").textContent =
        data.descricaoNivel;

    const progress = (data.score / data.maxScore) * 100;

    document
        .querySelector(".score-bar")
        .style.setProperty("--progress", `${progress}%`);

}

function renderDimensions(dimensoes) {

    const container = document.querySelector("#dimension-list");

    container.innerHTML = "";

    dimensoes.forEach(item => {

        container.insertAdjacentHTML("beforeend", `

            <div
                class="dimension"
                style="--value:${item.percentual}%">

                <div class="top">

                    <span>${item.nome}</span>

                    <strong class="${item.status}">
                        ${item.valor}/${item.maximo}
                    </strong>

                </div>

                <div class="progress">

                    <div
                        class="fill ${item.status}">
                    </div>

                </div>

            </div>

        `);

    });

}

function renderTimeline(evolucao) {

    const container = document.querySelector("#timeline");

    container.innerHTML = "";

    evolucao.forEach(item => {

        const classe = item.nivel.toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

        container.insertAdjacentHTML("beforeend", `

            <div class="step ${classe} ${item.ativo ? 'active' : ''}">

                <div class="label">

                    <strong>${item.titulo}</strong>

                    <small>${item.nivel}</small>

                </div>
                <div class="step-description">
                    <div class="progress-step">
                        <div class="fill"> </div>
                    </div>
                    <p>${item.descricao ?? ""}</p>
                </div>               

            </div>

        `);

    });

}

document.addEventListener('DOMContentLoaded', () => {

    const diagnosticoForm = document.querySelector('.diagnostico__form');

    // Não faz nada nas outras páginas
    if (!diagnosticoForm) return;

    const diagnosticoFormContent= document.querySelector('.diagnostico');
    const diagnosticoSection = document.querySelector('.section-diagnostico');
    const resultSection = document.querySelector('.section-result');

    // Oculta inicialmente
    //if (diagnosticoSection) diagnosticoSection.style.display = 'none';
    //if (resultSection) resultSection.style.display = 'none';

    // Observa quando o .cf-success for criado
    const observer = new MutationObserver(() => {

        const success = diagnosticoForm.querySelector('.cf-success');

        if (!success) return;

        // Esconde a mensagem de sucesso criada pela função
        success.style.display = 'none';

        // Esconde o bloco inteiro do formulário
        diagnosticoFormContent.style.display = 'none';

        // Exibe o quiz
        if (diagnosticoSection) {
            diagnosticoSection.style.display = '';

            setTimeout(() => {
                // Aguarda o repaint antes de fazer o scroll
                requestAnimationFrame(() => {
                    const top = diagnosticoSection.getBoundingClientRect().top + window.pageYOffset - 80;

                    window.scrollTo({
                        top,
                        behavior: 'smooth'
                    });
                });
            }, 100);            
        }

        // Não precisa mais observar
        observer.disconnect();

    });

    observer.observe(diagnosticoForm, {
        childList: true,
        subtree: true
    });

});


/* Diagnostico em forma de Wizard */

document.addEventListener('DOMContentLoaded', function () {

  const diagnostico = document.querySelector('.diagnostico__topicos');

  if (!diagnostico) return;


  const slider = diagnostico.querySelector('.diagnostico__slider');

  const perguntas = Array.from(
    slider.querySelectorAll('.diagnostico__pergunta')
  );


  const progressoAtual = diagnostico.querySelector(
    '.diagnostico__progresso-atual'
  );

  const progressoTotal = diagnostico.querySelector(
    '.diagnostico__progresso-total'
  );

  const bulletsContainer = diagnostico.querySelector(
    '.diagnostico__bullets'
  );

  const btnVoltar = diagnostico.querySelector(
    '.diagnostico__btn--voltar'
  );

  const btnAvancar = diagnostico.querySelector(
    '.diagnostico__btn--avancar'
  );


  const totalPerguntas = perguntas.length;

  let perguntaAtual = 0;

  // Evita clique duplo durante a animação
  let animando = false;


  /* =========================================
     CONFIGURAÇÃO INICIAL
  ========================================= */

  progressoTotal.textContent = totalPerguntas;


  // Cria os bullets automaticamente
  perguntas.forEach(function (_, index) {

    const bullet = document.createElement('span');

    bullet.classList.add('diagnostico__bullet');

    bullet.dataset.index = index;

    bulletsContainer.appendChild(bullet);

  });


  /* =========================================
     MOSTRAR PERGUNTA
  ========================================= */

  function mostrarPergunta(novoIndex, direcao = 'next') {

    if (
      novoIndex < 0 ||
      novoIndex >= totalPerguntas ||
      novoIndex === perguntaAtual ||
      animando
    ) {
      return;
    }


    animando = true;

    const perguntaAnterior = perguntas[perguntaAtual];
    const novaPergunta = perguntas[novoIndex];


    // Define a posição inicial da nova pergunta
    if (direcao === 'next') {

      novaPergunta.style.transform = 'translateX(100%)';

    } else {

      novaPergunta.style.transform = 'translateX(-100%)';

    }


    novaPergunta.style.position = 'absolute';
    novaPergunta.style.visibility = 'visible';
    novaPergunta.style.opacity = '1';


    // Força o browser a aplicar a posição inicial
    novaPergunta.offsetHeight;


    // Pergunta anterior sai
    perguntaAnterior.classList.remove('is-active');
    perguntaAnterior.classList.add('is-prev');


    // Nova pergunta entra
    novaPergunta.classList.add('is-active');

    novaPergunta.style.transform = 'translateX(0)';


    // Atualiza índice
    perguntaAtual = novoIndex;


    atualizarProgresso();
    atualizarBotoes();


    // Depois da animação
    setTimeout(function () {

      perguntaAnterior.classList.remove('is-prev');

      perguntaAnterior.style.position = 'absolute';
      perguntaAnterior.style.transform =
        direcao === 'next'
          ? 'translateX(-100%)'
          : 'translateX(100%)';

      perguntaAnterior.style.opacity = '0';
      perguntaAnterior.style.visibility = 'hidden';


      novaPergunta.style.position = 'relative';

      animando = false;

    }, 0);

  }


  /* =========================================
     PROGRESSO
  ========================================= */

  function atualizarProgresso() {

    // 1 de 18
    progressoAtual.textContent = perguntaAtual + 1;


    const bullets = bulletsContainer.querySelectorAll(
      '.diagnostico__bullet'
    );


    bullets.forEach(function (bullet, index) {

      bullet.classList.remove(
        'is-active',
        'is-completed'
      );


      if (index === perguntaAtual) {

        bullet.classList.add('is-active');

      } else if (index < perguntaAtual) {

        bullet.classList.add('is-completed');

      }

    });

  }


  /* =========================================
     BOTÕES
  ========================================= */

  function atualizarBotoes() {

    // Primeira pergunta
    btnVoltar.disabled = perguntaAtual === 0;


    // Última pergunta
    if (perguntaAtual === totalPerguntas - 1) {

      btnAvancar.textContent = 'Finalizar diagnóstico →';

    } else {

      btnAvancar.textContent = 'Avançar →';

    }

  }


  /* =========================================
     VERIFICAR RESPOSTA
  ========================================= */

  function perguntaTemResposta(index) {

    return !!perguntas[index].querySelector(
      'input[type="radio"]:checked'
    );

  }


  /* =========================================
     AVANÇAR
  ========================================= */

  btnAvancar.addEventListener('click', function () {
    // Se não respondeu
    if (!perguntaTemResposta(perguntaAtual)) {
      const pergunta = perguntas[perguntaAtual];
      pergunta.classList.add('is-error');

      setTimeout(function () {
        pergunta.classList.remove('is-error');
      }, 500);

      return;
    }

    // Última pergunta
    if (perguntaAtual === totalPerguntas - 1) {
      loadResult();
      return;
    }

    mostrarPergunta(
      perguntaAtual + 1,
      'next'
    );

  });

  /* =========================================
     VOLTAR
  ========================================= */

  btnVoltar.addEventListener('click', function () {

    if (perguntaAtual > 0) {

      mostrarPergunta(
        perguntaAtual - 1,
        'prev'
      );

    }

  });


  /* =========================================
     CLIQUE NA RESPOSTA
  ========================================= */

  perguntas.forEach(function (pergunta, index) {

    const radios = pergunta.querySelectorAll(
      'input[type="radio"]'
    );


    radios.forEach(function (radio) {

      radio.addEventListener('change', function () {

        // Pequeno delay para o usuário perceber a seleção
        setTimeout(function () {

          // Só avança se ainda estiver nessa pergunta
          if (
            perguntaAtual === index &&
            perguntaAtual < totalPerguntas - 1
          ) {

            mostrarPergunta(
              perguntaAtual + 1,
              'next'
            );

          }

        }, 250);

      });

    });

  });


  /* =========================================
     ESTADO INICIAL
  ========================================= */

  perguntas.forEach(function (pergunta, index) {

    if (index === 0) {

      pergunta.classList.add('is-active');

      pergunta.style.position = 'relative';
      pergunta.style.transform = 'translateX(0)';
      pergunta.style.opacity = '1';
      pergunta.style.visibility = 'visible';

    } else {

      pergunta.style.position = 'absolute';
      pergunta.style.transform = 'translateX(100%)';
      pergunta.style.opacity = '0';
      pergunta.style.visibility = 'hidden';

    }

  });


  atualizarProgresso();
  atualizarBotoes();

  const btnRenewDiagnostic = document.querySelector(
    '.btnRenewDiagnostic'
    );

    if (btnRenewDiagnostic) {

        btnRenewDiagnostic.addEventListener('click', function(e) {

            e.preventDefault();

            reiniciarDiagnostico();

        });

    }



    function reiniciarDiagnostico() {

        // ==============================
        // 1. Limpa todas as respostas
        // ==============================

        perguntas.forEach(function (pergunta) {

            pergunta
                .querySelectorAll('input[type="radio"]')
                .forEach(function (radio) {
                    radio.checked = false;
                });

        });


        // ==============================
        // 2. Reseta o índice
        // ==============================

        perguntaAtual = 0;
        animando = false;


        // ==============================
        // 3. Reseta visual das perguntas
        // ==============================

        perguntas.forEach(function (pergunta, index) {

            pergunta.classList.remove(
                'is-active',
                'is-prev',
                'is-error'
            );

            pergunta.style.transition = 'none';

            if (index === 0) {

                pergunta.style.position = 'relative';
                pergunta.style.transform = 'translateX(0)';
                pergunta.style.opacity = '1';
                pergunta.style.visibility = 'visible';

                pergunta.classList.add('is-active');

            } else {

                pergunta.style.position = 'absolute';
                pergunta.style.transform = 'translateX(100%)';
                pergunta.style.opacity = '0';
                pergunta.style.visibility = 'hidden';

            }

        });


        // ==============================
        // 4. Reativa as transições
        // ==============================

        requestAnimationFrame(function () {

            perguntas.forEach(function (pergunta) {
                pergunta.style.transition = '';
            });

        });


        // ==============================
        // 5. Atualiza progresso
        // ==============================

        atualizarProgresso();


        // ==============================
        // 6. Atualiza botões
        // ==============================

        atualizarBotoes();


        // ==============================
        // 7. Ajusta altura
        // ==============================

        if (typeof ajustarAlturaSlider === 'function') {
            ajustarAlturaSlider();
        }


        // ==============================
        // 8. Restaura CTA / loader
        // ==============================

        const btn = document.querySelector(
            '.diagnostico__cta a'
        );

        const btnLoader = document.querySelector(
            '.diagnostico__cta .loaderContent'
        );

        if (btn) {
            btn.style.display = '';
        }

        if (btnLoader) {
            btnLoader.style.display = 'none';
        }


        // ==============================
        // 9. Volta para o início
        // ==============================

        const diagnostico = document.querySelector('.section-diagnostico');
        const result = document.querySelector('.diagnostico-result');

        if (diagnostico) {

            diagnostico.style.display = '';
            result.style.display = 'none';  

            setTimeout(function () {

                const posicao =
                    diagnostico.getBoundingClientRect().top +
                    window.scrollY -
                    80;

                window.scrollTo({
                    top: posicao,
                    behavior: 'smooth'
                });

            }, 100);

        }

    }

});


/* #######  SIEG ACADEMY ####### */
const academy = document.querySelector('.header--academy');

if (academy) {

    const menu = academy.querySelector('.mobile-menu');
    const open = academy.querySelector('.header__toggle');
    const close = academy.querySelector('.mobile-menu__close');

    const items = academy.querySelectorAll('.mobile-menu__list li');
    const footer = academy.querySelector('.mobile-menu__footer');

    if (menu && open && close) {

        gsap.set(menu, {
            opacity: 0,
            visibility: 'hidden',
            pointerEvents: 'none'
        });

        gsap.set(items, {
            opacity: 0,
            y: 30
        });

        gsap.set(footer, {
            opacity: 0,
            y: 30
        });


        const openMenu = () => {

            document.body.classList.add('menu-academy-open');

            const tl = gsap.timeline();

            tl.set(menu, {
                visibility: 'visible',
                pointerEvents: 'auto'
            })

            .to(menu, {
                opacity: 1,
                duration: .35,
                ease: 'power2.out'
            })

            .to(items, {
                opacity: 1,
                y: 0,
                duration: .45,
                stagger: .08,
                ease: 'power2.out'
            }, '-=.1')

            .to(footer, {
                opacity: 1,
                y: 0,
                duration: .4,
                ease: 'power2.out'
            }, '-=.2');
        };


        const closeMenu = () => {

            const tl = gsap.timeline({
                onComplete: () => {

                    gsap.set(menu, {
                        visibility: 'hidden',
                        pointerEvents: 'none'
                    });

                    document.body.classList.remove('menu-academy-open');

                }
            });

            tl.to(items, {
                opacity: 0,
                y: 20,
                duration: .2,
                stagger: .04,
                ease: 'power2.in'
            })

            .to(footer, {
                opacity: 0,
                y: 20,
                duration: .2,
                ease: 'power2.in'
            }, '-=.15')

            .to(menu, {
                opacity: 0,
                duration: .3,
                ease: 'power2.in'
            }, '-=.1');
        };


        open.addEventListener('click', openMenu);

        close.addEventListener('click', closeMenu);
    }


    document.addEventListener('DOMContentLoaded', () => {
        const topicsSlider = document.querySelector('.hero-topics');

        if (!topicsSlider) return;

        const splide = new Splide(topicsSlider, {
            type: 'loop',
            drag: false,
            arrows: false,
            pagination: false,
            autoWidth: true,
            gap: '8px',
            autoplay: true,
            interval: 1000, // Aumentado para evitar travamentos
            speed: 8000,    // Velocidade de transição mais lenta
            pauseOnHover: false,
            pauseOnFocus: false,
            easing: 'linear',
            clones: 8,
            // Configurações de performance
            lazyLoad: 'nearby',
            preloadPages: 1,
            // Evita recálculos desnecessários
            updateOnMove: false,
        });

        // Força a atualização do carrossel
        splide.on('mounted', () => {
            // Ajusta a velocidade após o mount
            setTimeout(() => {
                splide.options.speed = 8000;
            }, 100);
        });

        splide.mount();
    });


    const videoPlayers = document.querySelectorAll('.video-player');

    if (videoPlayers) {

        videoPlayers.forEach(player => {

            const button = player.querySelector(".video-player__play");

            button.addEventListener("click", () => {

                const type = player.dataset.type;
                const src = player.dataset.video;

                if(type === "youtube"){

                    player.innerHTML = `
                        <iframe
                            src="${src}"
                            allow="autoplay; encrypted-media"
                            allowfullscreen>
                        </iframe>
                    `;

                }else{

                    player.innerHTML = `
                        <video controls autoplay playsinline>
                            <source src="${src}" type="video/mp4">
                        </video>
                    `;

                }

            });

        });
    }


    document.addEventListener('DOMContentLoaded', () => {
        const testimonialsSlider = document.querySelector('.academy-testimonials__slider');

        if (!testimonialsSlider) return;

        const splide2 = new Splide(testimonialsSlider, {
            type: 'loop',
            perPage:3,
            arrows: false,
            pagination: false,
            autoWidth: true,
            gap: '2rem',
            autoplay: true,
            interval: 1000, // Aumentado para evitar travamentos
            speed: 20000,    // Velocidade de transição mais lenta
            pauseOnHover: true,
            pauseOnFocus: false,
            easing: 'linear',
            clones: 8,
            // Configurações de performance
            lazyLoad: 'nearby',
            preloadPages: 1,
            // Evita recálculos desnecessários
            updateOnMove: false,
           /*  breakpoints: {
                1200: {
                    perPage:3
                },

                992: {
                    perPage:2
                },

                600:{
                    perPage:1
                }

            } */
        });

        splide2.mount();
    });

    document.addEventListener('DOMContentLoaded', () => {

        const coursesSlider = document.querySelector('.courses__slider');

        if (coursesSlider) {
           /*  new Splide(coursesSlider, {
                type: 'slide',
                autoplay: true,
                perPage: 2.4,
                perMove: 1,

                gap: '24px',

                arrows: false,
                pagination: false,

                speed: 700,

                breakpoints: {

                    1199: {
                        perPage: 1.7,
                        gap: '20px',
                    },

                    991: {
                        perPage: 1.4,
                        gap: '20px',
                    },

                    767: {
                        perPage: 1,
                        gap: '16px',
                    }

                }
            }).mount();*/

            new Splide(coursesSlider, {
                type: 'loop',
                perPage:3,
                arrows: false,
                pagination: false,
                gap: '2rem',
                autoplay: true,
                interval: 1000, // Aumentado para evitar travamentos
                speed: 20000,    // Velocidade de transição mais lenta
                pauseOnHover: true,
                pauseOnFocus: false,
                easing: 'linear',
                clones: 8,
                // Configurações de performance
                lazyLoad: 'nearby',
                preloadPages: 1,
                // Evita recálculos desnecessários
                updateOnMove: false,
                breakpoints: {

                    991: {
                        perPage: 2,
                        gap: '20px',
                    },

                    767: {
                        perPage: 1,
                        gap: '16px',
                    }

                }
            }).mount();
        } 

    });


    const faqItems = document.querySelectorAll(".faq__item");

    faqItems.forEach((item) => {
        const button = item.querySelector(".faq__question");
        const answer = item.querySelector(".faq__answer");

        button.addEventListener("click", () => {
            const isOpen = item.classList.contains("is-open");

            // Fecha todos os outros
            faqItems.forEach((otherItem) => {
            if (otherItem !== item) {
                const otherButton = otherItem.querySelector(".faq__question");
                const otherAnswer = otherItem.querySelector(".faq__answer");

                otherItem.classList.remove("is-open");
                otherButton.setAttribute("aria-expanded", "false");
                otherAnswer.setAttribute("aria-hidden", "true");
            }
            });

            // Abre/fecha o item atual
            if (isOpen) {
            item.classList.remove("is-open");
            button.setAttribute("aria-expanded", "false");
            answer.setAttribute("aria-hidden", "true");
            } else {
            item.classList.add("is-open");
            button.setAttribute("aria-expanded", "true");
            answer.setAttribute("aria-hidden", "false");
            }
        });
    });
}